import { render } from "./CartTableCustomOrderItem.vue?vue&type=template&id=0cb99998"
import script from "./CartTableCustomOrderItem.vue?vue&type=script&lang=js"
export * from "./CartTableCustomOrderItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__